export const groups = {
  notAssignedGroups:
    'Brak przypisanych grup. Wybierz jedną z listy lub utwórz nową, aby przypisać ją do opcji.',
  name: 'Nazwa',
  code: 'Kod',
  startAt: 'Data rozpoczęcia',
  expiresAt: 'Data ważności',
  addingGroup: 'Dodawanie nowej grupy',
  addGroup: 'Dodaj grupę',
  editGroup: 'Edytuj grupę',
  assignGroupToOption: 'Grupy nieprzypisane do opcji',
  deleteGroupTitle: 'Usuwanie grupy',
  deleteOptionTitle: 'Usuwanie opcji',
  deleteGroup: 'Usuń grupę',
  deletedQuestion: 'Czy na pewno chcesz usunąć grupę "{groupName}"?',
  deleteOptionQuestion: 'Czy na pewno chcesz usunąć opcje "{optionName}"?',
  options: 'Opcje przypisane do grupy',
  noOptions: 'Brak przypisanych opcji',
  linkGroup: 'Przypisz grupę',
  unLinkGroup: 'Usuń przypisanie',
  unLinkOption: 'Usuń przypisanie',
  linkOption: 'Przypisz opcję',
  selectOption: 'Wybierz opcję...',
  noGroups: 'Nie utworzono jeszcze żadnych grup',
  linkedOption: 'Przypisano nową opcję do grupy',
  unlinkedOption: 'Usunięto przypisanie opcji do grupy',
  manageGroupsDescription:
    'Zarządzaj grupami i ich przypisaniami do opcji. Grupy pozwalają na zbiorcze przypisywanie wielu opcji, co ułatwia organizację i zarządzanie ofertą.',
}
